import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ModalType } from "../../Enums/ModalType";

export interface ModalState {
  open: boolean;
  type?: ModalType;
}

export const modalInitialState: ModalState = {
  open: false,
  type: ModalType.General,
};

export const ModalSlice = createSlice({
  name: "modal",
  initialState: modalInitialState,
  reducers: {
    open: (_state, action: PayloadAction<ModalState>) => ({
      ...modalInitialState,
      ...action.payload,
      open: true,
    }),
    close: (state) => ({ ...state, open: false }),
  },
});
export const { open, close } = ModalSlice.actions;
export const selectModal = (state: any) => state.modal as ModalState;
export default ModalSlice.reducer;
